<div
  class="label"
  [ngClass]="{ border: isOpened }"
  tabindex="0"
  role="button"
  enterPress="onLabelClick()"
  (keydown.enter)="onLabelClick()"
  (click)="onLabelClick()"
>
  <span>
    {{ label ? label + ':' : '' }}
    <ng-container *ngIf="value?.hasOwnProperty('name'); else stringValue">
      {{ value.name | translate }}
    </ng-container>
    <ng-template #stringValue>
      {{ value | translate }}
    </ng-template>
  </span>
  <img
    src="assets/arrow-down-purple.svg"
    [@rotate]="isOpened ? 'rotated' : 'default'"
    alt="Arrow Down"
  />
</div>
<div class="background-shader" *ngIf="isOpened" (click)="onClickShader()"></div>
<div
  class="selector-container border"
  [@openCloseContainer]="isOpened ? 'visible' : 'hidden'"
>
  <div
    id="selector"
    class="selector"
    [@openClose]="isOpened ? 'open' : 'closed'"
  >
    <!-- Add New Option Item -->
    <div
      *ngIf="showAddNewOption"
      class="selector-item add-new-option"
      [style.width]="width - 24 + 'px'"
      [style.white-space]="nowrap"
      (click)="onAddNewOptionClick()"
    >
      <span class="add-icon">+</span>
      <span>{{ 'FINANCE_DROPDOWN.ADD_NEW_OPTION' | translate }}</span>
    </div>
    
    <div
      *ngIf="showAllValue"
      class="selector-item"
      [style.width]="width - 24 + 'px'"
      (click)="onSelectorItemClick(showAllValue)"
    >
      <!-- 
    tabindex="0"
    role="button"
    enterPress="onSelectorItemClick(showAllValue)"
    (keydown.enter)="onSelectorItemClick(showAllValue)" -->

      {{ showAllValue.name ?? showAllValue }}
    </div>
    <!-- prettier-ignore -->
    <ng-container *ngFor="let value of ignoreSort ?  values : (values | orderBy: '':false:'case-insensitive');">
      <div
        *ngIf="value?.name !== 'All' && value !== 'All'"
        class="selector-item"
        [style.width]="width - 24 + 'px'"

        

        (click)="onSelectorItemClick(value)"
      >

      <!-- tabindex="0"
      role="button"
      enterPress="onSelectorItemClick(value)"
      (keydown.enter)="onSelectorItemClick(value)" -->

        {{ (value.name ?? value) | translate }}
      </div>
    </ng-container>
  </div>
</div>
